<template>
    <div class="mx-auto">
        <b-row>
            <b-col md="3">
                <b-form-group
                        label="Valor Transferido (R$):"
                        label-for="valor"
                        class="text-label required">
                    <b-form-input v-model="comunicacaoTransferencia.valor" type="text" id="valor"
                                  @change="validarValor"
                                  :class="!validations.valor.valid ? 'is-invalid' : ''"
                                  @keyup="comunicacaoTransferencia.valor = formatarMonetario(comunicacaoTransferencia.valor)"/>
                    <div v-if="!validations.valor.valid" class="invalid-message">{{validations.valor.mensagem}}</div>
                </b-form-group>
            </b-col>
            <b-col md="3">
                <b-form-group
                        label="Data da Transferência:"
                        label-for="dataTransferencia"
                        class="text-label required">
                    <b-form-input
                        v-model="comunicacaoTransferencia.dataTransferencia"
                        v-validate="'required'"
                        id="dataTransferencia"
                        :max="maxDate"
                        name="dataTransferencia"
                        type="date"
                        @blur="validarDataTransferencia"
                        :class="!validations.data.valid ? 'is-invalid' : ''"
                    ></b-form-input>
                    <span v-show="errors.has('dataTransferencia')">A data inserida é inválida!</span>
                    <div v-if="!errors.has('dataTransferencia') && !validations.data.valid" class="invalid-message">O campo Data da Transferência é obrigatório.</div>
                    <div v-if="!validations.data.pastDate" class="invalid-message">A data inserida é maior que a data atual.</div>
                </b-form-group>
            </b-col>
        </b-row>

        <hr class="mt-4"/>

        <b-row>
            <b-col md="3">
                <b-form-group
                        label="CPF / CNPJ do Devedor:"
                        label-for="cpf"
                        class="text-label required">
                    <b-form-input
                            type="text"
                            id="num-documento"
                            data-vv-as="CPF"
                            v-model="comunicacaoTransferencia.cpfCnpjDevedor"
                            v-mask="['###.###.###-##', '##.###.###/####-##']"
                            @change="buscarDevedor"
                            :class="!validations.cpfCnpjDevedor.valid || !validations.cpf.valid || !validations.cnpj.valid ? 'is-invalid' : ''"
                    ></b-form-input>
                    <div v-if="!validations.cpfCnpjDevedor.valid" class="invalid-message">O campo CPF / CNPJ do Devedor é obrigatório.</div>
                    <div v-if="!validations.cpf.valid" class="invalid-message">CPF inválido.</div>
                    <div v-if="!validations.cnpj.valid" class="invalid-message">CNPJ inválido.</div>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group
                        label="Nome / Razão Social do Devedor:"
                        label-for="devedor"
                        class="text-label required" >
                    <b-input-group>
                        <b-form-input
                                type="text"
                                id="devedor"
                                v-model="comunicacaoTransferencia.nomeDevedor"
                                data-vv-as="devedor"
                                description="Devedor"
                                disabled
                                readonly
                        >
                        </b-form-input>
                        <b-button
                            id="adicionarDevedor"
                            class="icon-button"
                            title="Abrir Cadastro do Devedor"
                            variant="outline-primary"
                            @click="abrirModalDevedor()"
                        >
                            <i class="far fa-address-book fa-flip-horizontal"></i>
                        </b-button>
                    </b-input-group>
                </b-form-group>
            </b-col>
        </b-row>
<!--
        <hr v-if="comunicacaoTransferencia.titularReceita == 1" class="mt-4"/>

        <b-row v-if="comunicacaoTransferencia.titularReceita == 1">
            <b-col md="12">
                <p><b>Opções Complementares</b></p>
            </b-col>
            <b-col md="3">
                <b-form-group label label-for="enviarDocumentacao">
                    <b-form-checkbox v-model="comunicacaoTransferencia.enviarDocumentacao" id="enviarDocumentacao" name="check-button">
                        Enviar documentação gerada ao <b>E-mail</b>
                    </b-form-checkbox>
                </b-form-group>
            </b-col>
            <b-col md="4" style="margin-top: -8px;">
                <b-form-input v-model="comunicacaoTransferencia.email" type="text" id="email" maxlength="100"
                              @keyup="comunicacaoTransferencia.email = removeSpecialCharactersGeralVirgula(comunicacaoTransferencia.email)"/>
            </b-col>
        </b-row>
-->
        <hr class="mt-4"/>

        <b-row>
            <b-col>
                <b-row class="mt-1 align-items-center">
                    <div class="px-3">
                        <label class="text-bold">Observações:</label>
<!--                        <span v-if="comunicacaoTransferencia.titularReceita == 1">Indique abaixo as informações pertinentes à transferência de valores realizada para a conta da CES!</span>-->
                    </div>
                </b-row>
                <b-row class="mb-0">
                    <b-col>
                        <b-form-textarea
                            id="observacoes"
                            v-model="comunicacaoTransferencia.observacoes"
                            size="500"
                            placeholder=""
                            max-rows="10"
                        ></b-form-textarea>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>

        <hr class="mt-4"/>

        <b-row>
            <b-col sm="12" md="6">
                <label for="carregarArq">Anexar arquivo(s):</label>
                <b-form-group id="input-group-1" label="" label-for="parcelamento">
                    <b-form-file id="carregarArq" v-model="arquivo" @input="realizarUpload()"
                                 placeholder="Selecione um arquivo"
                                 accept="image/png|image/jpeg|image/jpg|text/plain"></b-form-file>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="4">
                <b-form-group
                        label="Informe o Setor responsável pela Requisição:"
                        label-for="setor"
                        class="text-label required">
                    <b-form-select v-model="comunicacaoTransferencia.codSetor"
                                   :class="!validations.setor.valid ? 'invalid-select' : ''">
                        <template v-slot:first>
                            <option :value="null">Selecionar</option>
                        </template>
                        <option
                            v-for="setor in dados.setores"
                            :key="setor.codSetor"
                            :value="setor.codSetor">
                                {{ setor.nome ? setor.nome : 'NENHUM' }}
                        </option>
                    </b-form-select>
                    <div v-if="!validations.setor.valid" class="invalid-message">O campo Setor é obrigatório.</div>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row v-for="arquivo in comunicacaoTransferencia.arquivos">
            <b-col md="6" class="mt-1">
                <a class="link" style="margin-left: 30px;" @click="obterAnexo(arquivo)">
                    {{ arquivo.nomeArquivo }}
                </a>
                <b-button class="ml-2"
                          variant="outline-warning"
                          @click="excluirArquivo(arquivo)">
                    <i class="fa fa-trash"></i>
                </b-button>
            </b-col>
        </b-row>
        <CompLoading ref="loading"/>
        <ModalIncluirDevedor
            ref="modalDevedor"
            @novoDevedor="novoDevedor"
            @cancelarNovoDevedor="cancelarNovoDevedor" />
        <ModalAlterarDevedor
                ref="modalAlterarDevedor"
                :loading="$refs.loading"
                @salvarDevedor="salvarDevedor"/>
    </div>
</template>

<script>
    import axios from 'axios';
    import formatarMixins from '../../../mixins/formatarMixins';
    import CompLoading from "../../shared/components/CompLoading";
    import ModalIncluirDevedor from "../../shared/components/ModalIncluirDevedor";
    import ModalAlterarDevedor from "../../shared/components/ModalAlterarDevedor";
    import moment from 'moment'

    export default {
        props: ['comunicacaoTransferencia','validations'],
        mixins: [ formatarMixins ],
        components: {CompLoading, ModalIncluirDevedor, ModalAlterarDevedor},
        data() {
            return {
                urlApi: null,
                token: null,
                arquivo: null,
                maxDate: null,
                dados: {
                    setores: [],
                    setoresFiltrados: [],
                }
            }
        },
        created () {
            this.$validator.extend('dateRange', {
                getMessage () {
                    return 'A data inserida é inválida!'
                },
                validate (value) {
                    return moment(value).isValid()
                }
            })
        },
        methods: {
            async listarSetores() {
                axios.get(`${this.urlApi}/v1/honorariosAcaoJudicial/listarSetores`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                    this.dados.setores = response.data
                    this.dados.setoresFiltrados = response.data
                });
            },
            async buscarDevedor() {
                this.$store.commit("setMessages", {});
                this.validations.cnpj.valid = true;
                this.validations.cpf.valid = true;

                if(this.comunicacaoTransferencia.cpfCnpjDevedor.length <= 14 && !this.validarCpf(this.comunicacaoTransferencia.cpfCnpjDevedor)) {
                    this.validations.cpf.valid = false;
                    this.cancelarNovoDevedor()
                    return;
                } else if(this.comunicacaoTransferencia.cpfCnpjDevedor.length > 14 && !this.validarCnpj(this.comunicacaoTransferencia.cpfCnpjDevedor)) {
                    this.validations.cnpj.valid = false;
                    this.cancelarNovoDevedor()
                    return;
                }

                this.comunicacaoTransferencia.codDevedor = null;

                let devedor = {
                    documento: this.comunicacaoTransferencia.cpfCnpjDevedor
                };

                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/receitasDiversas/obterContribuinte`, devedor, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    if(response.data != null && response.data != "") {
                        this.comunicacaoTransferencia.codDevedor = response.data.codContribuinte;
                        this.comunicacaoTransferencia.nomeDevedor = response.data.nome;
                    } else {
                        this.$refs.modalDevedor.abrirModalIncluirDevedorCpf(this.comunicacaoTransferencia.cpfCnpjDevedor);
                    }
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                });
            },

            abrirModalDevedor() {
                if (this.comunicacaoTransferencia.codDevedor != null) {
                    this.$refs.modalAlterarDevedor.carregarCadastro(this.comunicacaoTransferencia.codDevedor);
                } else {
                    this.$refs.modalDevedor.abrirModalDevedor({ modalTitulo: 'Cadastro do Devedor' });
                }
            },

            novoDevedor(contribuinte) {
                this.comunicacaoTransferencia.codDevedor = contribuinte.codContribuinte;
                this.comunicacaoTransferencia.nomeDevedor = contribuinte.nome;
                this.comunicacaoTransferencia.cpfCnpjDevedor = contribuinte.documento;
            },

            salvarDevedor(devedorSalvo) {
                this.comunicacaoTransferencia.codDevedor = devedorSalvo.codContribuinte;
                this.comunicacaoTransferencia.nomeDevedor = devedorSalvo.nome;
                this.comunicacaoTransferencia.cpfCnpjDevedor = devedorSalvo.documento;
            },

            cancelarNovoDevedor() {
                this.comunicacaoTransferencia.codDevedor = null;
                this.comunicacaoTransferencia.cpfCnpjDevedor = null;
                this.comunicacaoTransferencia.nomeDevedor = null;
            },

            realizarUpload() {
                this.$store.commit("setMessages", {});

                /* if(!this.arquivo.name.endsWith(".jpeg")
                    && !this.arquivo.name.endsWith(".jpg")
                    && !this.arquivo.name.endsWith(".png")
                    && !this.arquivo.name.endsWith(".pdf")) {
                    this.exibirMensagem("Formato do arquivo inválido.");
                } else */ if((this.arquivo.size / 1024) / 1024 > 50.0) {
                    this.exibirMensagem("O tamanho do arquivo ultrapassa o limite permitido pelo sistema (50Mb)!")
                } else {
                    let arquivoConvertido = null;
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        let arquivo = {
                            base64: e.target.result
                        };
                        arquivoConvertido = arquivo;
                    };
                    reader.readAsDataURL(this.arquivo);
                    reader.onloadend = () => this.executeUpload(arquivoConvertido);
                }
            },
            executeUpload(arquivoConvertido) {
                arquivoConvertido.nomeArquivo = this.arquivo.name;
                this.comunicacaoTransferencia.arquivos.push(arquivoConvertido);
                this.arquivo = null;
            },
            excluirArquivo(arquivo) {
                const index = this.comunicacaoTransferencia.arquivos.indexOf(arquivo);
                this.comunicacaoTransferencia.arquivos.splice(index, 1);
            },
            validarCnj() {
                if(this.comunicacaoTransferencia.cnj.length < 25 || !this.validaCnj(this.comunicacaoTransferencia.cnj)) {
                    this.exibirMensagem("CNJ inválido.");
                }
            },
            validarDataTransferencia () {
                this.validations.data.valid = true;
                this.$validator.validateAll()
                if(!this.verificarValorVazio(this.comunicacaoTransferencia.dataTransferencia) &&
                        new Date(this.comunicacaoTransferencia.dataTransferencia) > new Date()) {
                    this.validations.data.pastDate = false;
                } else {
                    this.validations.data.pastDate = true;
                }
            },
            validarValor() {
                let valor = this.tratarCamposNumericos(this.comunicacaoTransferencia.valor)
                if(valor <= 0) {
                    this.$emit('alterarValidadeValor', false);
                } else {
                    this.$emit('alterarValidadeValor', true);
                }
            },
            async obterAnexo(anexo) {
                if(anexo.base64 == null && anexo.codAnexo != null) {
                    await axios.get(`${this.urlApi}/v1/pesquisas/downloadAnexoBase64/${anexo.codAnexo}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        },
                    }).then(response => {
                        if(!response.data || response.data == null){
                            this.$store.commit("setMessages", { message: 'Erro!', errors: ['Arquivo não encontrado para download.'] });
                            return;
                        }

                        var a = document.createElement("a");
                        a.href = response.data.base64;
                        a.download = response.data.nomeArquivo;
                        a.click();
                    }).catch((error) => {
                        this.exibirErro(error)
                    });
                } else {
                    var a = document.createElement("a");
                    a.href = anexo.base64;
                    a.download = anexo.nomeArquivo;
                    a.click();
                }
            },
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            this.listarSetores();

            var dataAtual = new Date();
            let ano = dataAtual.getFullYear();
            let mes = dataAtual.getMonth() + 1;
            this.maxDate = ano + "-" + (mes < 10 ? "0" : "") + mes + "-" + (dataAtual.getDate() < 10 ? "0" : "") + dataAtual.getDate();
        }
    }
</script>
<style scoped>
input:invalid {
    border-color: red;
}
input:invalid + span {
    color: red;
}
.icon-button {
    font-size: 1.5rem;
    margin-left: 1rem;
    padding: 0 0.5rem;
}
.icon-button i {
    color: inherit;
    vertical-align: middle;
}
</style>
